import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../../context/AuthContext';
import DataTable from 'react-data-table-component';
import { FaUserFriends } from 'react-icons/fa';
import { MdAdd, MdDelete, MdEdit } from 'react-icons/md';
import styles from "./companiesAf.module.css";
import { IoCloseSharp } from "react-icons/io5";
import Swal from 'sweetalert2';
import { api } from '../../utils/services/api';
import { APP_OPTIONS, SERVICE } from '../../utils/constants/services';
import Select from 'react-select'
import { Accordion, Card, Collapse, useAccordionButton } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

export default function ModalCompaniesAF(props) {
    const { show, setShow, ofices, dataEdit, setDataEdit, handleUpdate, estados, municipios } = props;
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");

    const [nameA, setNameA] = useState("");
    const [member, setMember] = useState("");
    const [descriptionA, setDescriptionA] = useState("");
    const [isOpen, setIsOpen] = useState(false);

    const [sucursalSelect, setSucursalSelect] = useState(null);
    const [menuActive, setMenuActive] = useState("menu01");

    const [stateSelect, setStateSelect] = useState(null);
    const [municipalFilter, setMunicipalFilter] = useState([]);
    const [companiesAll, setCompaniesAll] = useState([]);
    const [companiesAsig, setCompaniesAsig] = useState([]);
    const [municipalSelect, setMunicipalSelect] = useState(null);
    const [sucursalesAgregadas, setSucursalesAgregadas] = useState([]);

    const columns1 = [

        {
            name: 'Nombre',
            selector: row => row.name,
        },
        {
            name: 'Municipio',
            selector: row => row.location,
        },
        // {
        //     name: 'Acciones',
        //     cell: (row) => {
        //         return (
        //             <div style={{ display: "flex" }}>
        //                 <button className='btn btn-sm btn-primary'><MdAdd /></button>&nbsp;
        //             </div>
        //         )
        //     },
        // }
    ];
    const columns3 = [
        {
            name: '#',
            selector: row => row.number,
            cell: (row) => {
                return (
                    <div style={{ display: "flex" }}>
                        {row.number}<span style={{ marginLeft: "10px", display: row.id != 0 ? "none" : "" }} className="badge bg-primary">Nueva</span>
                    </div>
                )
            },
        },
        {
            name: 'Estado',
            selector: row => row.stateName,
        },
        {
            name: 'Municipio',
            selector: row => row.municipalityName,
        },
        {
            name: 'Descripcion',
            selector: row => row.description,
        },
        {
            name: 'Acciones',
            cell: (row) => {
                return (
                    <div style={{ display: "flex" }}>
                        <button className='btn btn-sm btn-danger' onClick={() => handleDeletesuc(row.id, row.number)}><MdDelete /></button>&nbsp;
                    </div>
                )
            },
        }
    ];
    const columns2 = [
        {
            name: 'Nombre',
            selector: row => row.description,
        },
        {
            name: 'Municipio',
            selector: row => row.municipalityName,
        },
        // {
        //     name: 'Acciones',
        //     cell: (row) => {
        //         return (
        //             <div style={{ display: "flex" }}>
        //                 <button className='btn btn-sm btn-primary'><MdAdd /></button>&nbsp;
        //             </div>
        //         )
        //     },
        // }
    ];
    const handleDeletesuc = (id, number) => {
        if (id === 0) {
            let array = [];
            let cont = 1;
            for (let index = 0; index < sucursalesAgregadas.length; index++) {
                const element = sucursalesAgregadas[index];
                if (element.number != number) {
                    array.push({ ...element, number: cont });
                    cont = cont + 1;
                }

            }
            setSucursalesAgregadas(array);
        }
        else {
            Swal.fire({
                title: "¿Esta segur@ que desea eliminar la sucursal?",
                showCancelButton: true,
                confirmButtonText: "Eliminar",
                denyButtonText: "Cancelar"
            }).then((result) => {
                if (result.isConfirmed) {
                    api(SERVICE.deleteCompanieSucAf + `?id=${id}`, {}, "DELETE")
                        .then((data) => {
                            let array = [];
                            let cont = 1;
                            for (let index = 0; index < sucursalesAgregadas.length; index++) {
                                const element = sucursalesAgregadas[index];
                                if (element.number != number) {
                                    array.push({ ...element, number: cont });
                                    cont = cont + 1;
                                }
                            }
                            setSucursalesAgregadas(array);
                            handleUpdate();
                        })
                        .catch((err) => {
                            console.log(err);
                        })
                }
            });
        }
    }
    const handleAgregarSucursal = async () => {
        if (stateSelect === null || municipalSelect === null || descriptionA === "") {
            Swal.fire({
                text: 'Favor de llenar todos los campos',
                icon: 'error',
                confirmButtonText: 'Aceptar'
            })

        }
        else {
            if (dataEdit != null) {
                let companyId = dataEdit.id;
                let payload = {
                    affiliatedCompanyId: companyId,
                    description: descriptionA,
                    stateId: stateSelect.value,
                    municipalityId: municipalSelect.value
                }
                await api(SERVICE.setCompanieSucAf, payload, "POST")
                    .then((data) => {
                        let idSucursal = data.data.data;
                        let arrayTemp = [...sucursalesAgregadas];
                        arrayTemp.push({
                            id: idSucursal,
                            number: (arrayTemp.length + 1),
                            stateName: stateSelect.label,
                            stateid: stateSelect.value,
                            municipalityName: municipalSelect.label,
                            municipalityId: municipalSelect.value,
                            description: descriptionA
                        });
                        setDescriptionA("");
                        setMunicipalSelect(null);
                        setStateSelect(null);
                        setSucursalesAgregadas(arrayTemp);
                        handleUpdate();
                        Swal.fire({
                            position: "center",
                            icon: "success",
                            title: "Sucursal agregada",
                            showConfirmButton: false,
                            timer: 1500
                        });
                    })
                    .catch((err) => {
                        console.log(err);
                    })

            }
            else {
                let arrayTemp = [...sucursalesAgregadas];
                arrayTemp.push({
                    id: 0,
                    number: (arrayTemp.length + 1),
                    stateName: stateSelect.label,
                    stateid: stateSelect.value,
                    municipalityName: municipalSelect.label,
                    municipalityId: municipalSelect.value,
                    description: descriptionA
                });
                setDescriptionA("");
                setMunicipalSelect(null);
                setStateSelect(null);
                setSucursalesAgregadas(arrayTemp);
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Sucursal agregada",
                    showConfirmButton: false,
                    timer: 1500
                });
            }

        }
    }
    const handleAgregar = async () => {
        if (name === "") {
            Swal.fire({
                text: 'Favor de llenar todos los campos',
                icon: 'error',
                confirmButtonText: 'Aceptar'
            })
        }
        else {
            if (dataEdit != null) {
                let companyId = dataEdit.id;
                let companyOfId = 0;
                let payload = {
                    Id: dataEdit.id,
                    name: name,
                    membershipNumber: member
                }
                await api(SERVICE.updateCompanieAf, payload, "PUT")
                    .then((data) => {
                        //companyId = data.data.data;
                    })
                    .catch((err) => {
                        console.log(err);
                    })
                if (companyId != 0) {
                    if (sucursalesAgregadas.length > 0) {
                        for (let index = 0; index < sucursalesAgregadas.length; index++) {
                            const element = sucursalesAgregadas[index];
                            let payload = {
                                id: element.id,
                                affiliatedCompanyId: companyId,
                                description: element.description,
                                stateId: element.stateid,
                                municipalityId: element.municipalityId
                            }
                            if (element.id === 0) {
                                await api(SERVICE.setCompanieSucAf, payload, "POST")
                                    .then((data) => {
                                        companyOfId = data.data.data;
                                    })
                                    .catch((err) => {
                                        console.log(err);
                                    })
                            }

                        }
                    }

                }
                handleUpdate();
                setShow(false);
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Guardado correctamente",
                    showConfirmButton: false,
                    timer: 1500
                });
            }
            else {
                let companyId = 0;
                let companyOfId = 0;
                let payload = {
                    CompanyName: name
                }
                await api(SERVICE.setCompanieAf, payload, "POST")
                    .then((data) => {
                        companyId = data.data.data;
                    })
                    .catch((err) => {
                        console.log(err);
                    })
                if (companyId != 0) {
                    if (sucursalesAgregadas.length > 0) {
                        for (let index = 0; index < sucursalesAgregadas.length; index++) {
                            const element = sucursalesAgregadas[index];
                            let payload = {
                                CompanyId: companyId,
                                Description: element.description,
                                CentralOfficesId: element.idSucursal
                            }
                            await api(SERVICE.setCompanieSucAf, payload, "POST")
                                .then((data) => {
                                    companyOfId = data.data.data;
                                })
                                .catch((err) => {
                                    console.log(err);
                                })
                        }
                    }

                }
                handleUpdate();
                setShow(false);
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Guardado correctamente",
                    showConfirmButton: false,
                    timer: 1500
                });
            }

        }

    }
    const handleGetCompaniesAf = () => {
        api(SERVICE.getCompaniesAf)
            .then(async (data) => {
                if (data.data.data) {
                    const promises = data.data.data.map(async (companieMain) => {
                        const response = await api(SERVICE.getCompaniesAfSuc + companieMain.id);
                        return response.data.data.map((dataComplement) => ({
                            id: dataComplement.affiliatedCompanyId,
                            name: companieMain.name,
                            member: companieMain.membershipNumber,
                            location: `${dataComplement.stateName} - ${dataComplement.municipalityName}`,
                        }));
                    });

                    const results = await Promise.all(promises);
                    setCompaniesAll(results.flat()); // <- Una sola actualización
                }
            })
            .catch((err) => console.log(err));
    };


    useEffect(() => {
        if (!show) {
            setDataEdit(null);
            setNameA("");
            setDescriptionA("");
            setName("");
            setMember("");
            setDescription("");
            setDescriptionA("");
            setStateSelect(null);
            setMunicipalSelect(null);
            setMunicipalSelect(null);
            setSucursalesAgregadas([]);
        }
        else {

        }
    }, [show])
    useEffect(() => {
        if (dataEdit != null && show) {
            console.log(dataEdit);
            setName(dataEdit.name);
            setMember(dataEdit.membershipNumber);
            let array = [];
            if (dataEdit.sucursales) {
                for (let index = 0; index < dataEdit.sucursales.length; index++) {
                    const element = dataEdit.sucursales[index];
                    array.push({
                        ...element,
                        id: element.id,
                        number: (index + 1)

                    })
                }
            }
            setSucursalesAgregadas(array);
        }
    }, [dataEdit, show])

    useEffect(() => {
        if (!show) {
            //setName("");
        }
        else {
            handleGetCompaniesAf();
        }
    }, [show])
    useEffect(() => {
        console.log("companiesAll", companiesAll)
    }, [companiesAll])
    useEffect(() => {
        if (stateSelect != null && municipios && municipios.length > 0) {
            setMunicipalSelect(null);
            let ArrayTemp = [];
            for (let index = 0; index < municipios.length; index++) {
                const element = municipios[index];
                if (element.stateId === stateSelect.value) {
                    ArrayTemp.push(element);
                }

            }
            setMunicipalFilter(ArrayTemp);
        }
    }, [stateSelect, municipios])


    return (
        <>
            <div className={styles.bodyModal} style={{ display: show ? "" : "none" }}>
                <div className={`${styles.containerFormMain} animate__animated animate__fadeInDown`} style={{ display: show ? "" : "none" }}>
                    <div className={styles.headerForm}>
                        <h5>{dataEdit != null ? "Editar Empresa Afiliada" : "Nueva Empresa Afiliada"}</h5>
                        <div className={styles.icon} onClick={() => setShow(false)}>
                            <IoCloseSharp />
                        </div>

                    </div>

                    <div className={styles.containerForm} style={{ display: menuActive == "menu01" ? "flex" : "none" }}>
                        <div className={styles.itemForm}>
                            <label class="form-label">Nombre empresa*:</label>
                            <input type="text" class="form-control" placeholder="Nombre empresa" value={name} onChange={(e) => setName(e.target.value)} />
                        </div>
                        <div className={styles.itemForm}>
                            <label class="form-label">Membresía*:</label>
                            <input type="text" class="form-control" placeholder="Membresía" value={member} onChange={(e) => setMember(e.target.value)} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "100%" }}>
                            <Accordion>
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>Agregar sucursales</Accordion.Header>
                                    <Accordion.Body>
                                        <div className={styles.containerForm} style={{ display: "flex" }}>
                                            <div className={styles.itemForm} style={{ width: "100%" }}>
                                                <label class="form-label">Descripcion*:</label>
                                                <input type="text" class="form-control" placeholder="Descripcion" value={descriptionA} onChange={(e) => setDescriptionA(e.target.value)} />
                                            </div>
                                            <div className={styles.itemForm}>
                                                <label class="form-label">Estado*:</label>
                                                <Select placeholder="Selecciona un estado" options={estados} class="form-control" value={stateSelect} onChange={(e) => setStateSelect(e)} />
                                            </div>
                                            <div className={styles.itemForm}>
                                                <label class="form-label">Municipio*:</label>
                                                <Select placeholder="Selecciona un municipio" options={municipalFilter} class="form-control" value={municipalSelect} onChange={(e) => setMunicipalSelect(e)} />
                                            </div>
                                            <div className={styles.itemForm} style={{ width: "100%" }}>
                                                <button className='btn btn-success' onClick={() => handleAgregarSucursal()}>Agregar</button>&nbsp;&nbsp;
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                            </Accordion>

                        </div>





                        <div className={styles.itemForm} style={{ width: "100%" }}>
                            <h5>Sucursales Agregadas</h5>
                            <DataTable
                                columns={columns3}
                                data={sucursalesAgregadas}
                                customStyles={APP_OPTIONS.TABLE_SETTING}
                                pagination
                                persistTableHead
                            />
                        </div>
                    </div>

                    <div className={styles.containerBtn}>
                        <button className='btn btn-success' onClick={() => handleAgregar()}>{dataEdit != null ? "Editar" : "Crear"}</button>&nbsp;&nbsp;
                        <button className='btn btn-danger' onClick={() => setShow(false)}>Cancelar</button>
                    </div>
                </div>
            </div>
        </>
    );
}